import Backbone from "backbone";
import DeliveryAddressMapPopinView from "./DeliveryAddressMapPopinView";
import $ from "jquery";
import { MagnificPopup } from "../../common/dynamic-imports/MagnificPopup";

  var deliveryAddressMapPopinView;

  export default Backbone.View.extend({
  initialize: function initialize() {
      this.magnificPopup = new MagnificPopup(this.$el.find('.js-showMapPopinButton'), {
        type: 'inline',
        midClick: true,
        callbacks: {
          open: () => {
            createPopinView(this.magnificPopup.instance.content, this.magnificPopup.instance.currItem.el);
          },
          afterClose: disablePopinView
        }
      });
    }
  });

  function createPopinView(content, $currentTarget) {
    if (content.length) {
      deliveryAddressMapPopinView = new DeliveryAddressMapPopinView({
        el: content,
        pushpin: $currentTarget.data('pushpin') || '',
        geoloc: $currentTarget.data('geoloc') || '',
        shopId: $currentTarget.data('shopid'),
        relayId: $currentTarget.data('relayid')
      });
    }
  }

  function disablePopinView() {
    if (deliveryAddressMapPopinView) {
      deliveryAddressMapPopinView.stopListening();
      deliveryAddressMapPopinView.undelegateEvents();
    }
  }
